import { ChatMessageContact } from '@src/types';
import { useMemo } from 'react';

const usePrimaryContactPhone = (contact?: ChatMessageContact) => {
  const mainPhone = useMemo(() => {
    let wspPhone = contact?.phones?.find(phone => !!phone?.wa_id);
    wspPhone = wspPhone ?? contact?.phones.at(0);

    return wspPhone;
  }, [contact]);

  return mainPhone;
};

export default usePrimaryContactPhone;
